<template>
  <div>
    <div class="mb-10" id="daily-pattern-chart"></div>
    <div class="text-center text-default">Load profile</div>
  </div>
</template>
<script>
import moment from 'moment'
import { Chart } from '@antv/g2'

export default {
  // name: 'LoadPattern',
  props: ['pattern', 'shouldReact'],
  data: function () {
    return {
      chart: null,
      oldPatern: [],
    }
  },
  methods: {
    moment,
    drawPatternChart() {
      console.log('Drawing pattern chart')
      if (this.chart) {
        this.chart.destroy()
      }

      const data = this.pattern.map((row) => {
        return {
          hour: row.hour,
          volume: row.volume,
        }
      })

      const chart = new Chart({
        container: 'daily-pattern-chart',
        autoFit: true,
        height: 150,
        padding: [20, 60, 20, 60],
      })

      chart.data(data)
      chart.scale('volume', {
        alias: 'Volume',
        nice: true,
        min: 0,
      })

      chart.axis('hour', {
        range: [0, 1],
      })
      chart.axis('volume', true)

      chart.tooltip({
        showMarkers: false,
      })
      chart.line().position('hour*volume').shape('hv')
      // chart.area().position('hour*volume').shape('hv')
      chart.tooltip({
        showCrosshairs: true,
      })
      chart.interaction('element-active')

      // 添加文本标注
      // data.forEach((item) => {
      //   chart.annotation().text({
      //     position: [item.hour, item.volume],
      //     content: item.volume,
      //     style: {
      //       textAlign: 'center',
      //     },
      //     offsetY: -30,
      //   })
      // })
      chart.render()

      this.chart = chart
    },
  },
  beforeCreate() {},
  watch: {
    pattern: {
      handler(pattern) {
        // console.log(oldVal, newVal)
        // if (this.oldPatern != pattern) {
        //   this.drawPatternChart()
        // } else {
        //   var shouldRedraw = false
        //   for (var i = 0; i < pattern.length; i++) {
        //     console.log(
        //       `Old ${this.oldPatern[i].volume} - New ${pattern[i].volume}`
        //     )
        //     if (this.oldPatern[i].volume != pattern[i].volume) {
        //       console.log('Should redraw')
        //       shouldRedraw = true
        //     }
        //   }

        //   if (shouldRedraw) {
        console.log('Should react', this.shouldReact)
        if (this.shouldReact) {
          this.drawPatternChart()
        }
        // }
        // }
      },
      deep: true,
    },
  },
  mounted() {
    this.drawPatternChart()
  },
}
</script>

<style>
[data-kit-theme='default'] .ant-table-thead > tr > th,
[data-kit-theme='default'] .ant-table-tbody > tr > td {
  padding: 4px 8px;
}

.ant-col.ant-form-item-label {
  padding-bottom: 0px;
}
.ant-col.ant-form-item-label label {
  margin-bottom: 0px;
}
</style>